import { media } from '@domain-group/fe-brary';
import { css } from '@emotion/core';
export var featureStepper = /*#__PURE__*/css("display:flex;flex-direction:row;align-items:center;gap:24px;justify-content:space-between;", media('>=tablet'), "{justify-content:flex-start;}");
export var label = {
  name: "1hvnx09",
  styles: "width:112px;display:flex;gap:8px;align-items:center;"
};
export var icon = {
  name: "19rsff",
  styles: "width:18px;height:18px;"
};